import Colors from '@/constants/Colors';
import { motion } from 'framer-motion';
import styled from 'styled-components';

export const StyledBubbleTextBox = styled(motion.div)`
  color: ${({ $color }) => $color ?? Colors.textDarkComic};
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: absolute;
  z-index: 99;
  top: ${(props) => props.$points[0][1]}%;
  left: ${(props) => props.$points[0][0]}%;
  width: ${(props) => getBubbleWidth(props.$points)}%;
  height: ${(props) => getBubbleHeight(props.$points)}%;
  text-align: center;

  .responsive-text {
    padding: 5px;
  }
`;

export const StyledBubbleText = styled(motion.div)`
  font-kerning: normal;
  ${({ $textStyle }) => cssByTextStyle($textStyle)}
`;

const getBubbleWidth = (points) => points[1][0] - points[0][0];
const getBubbleHeight = (points) => points[2][1] - points[0][1];

const cssByTextStyle = (textStyle) => {
  switch (textStyle) {
    case 'narrator':
      return `
        line-height: 1.3;
        //font-family: comic;
        font-family: comicSans;
        letter-spacing: 0.03em;
        //font-weight: 600;
      `;
    case 'shortStoryStyle':
      return `
        font-family: shortStoryStyle;
      `;
    case 'speech':
    default:
      return `
          line-height: 1.28;
          //font-family: comic;
          font-family: comicSans;
          text-transform: uppercase;
          //letter-spacing: 0.05em;
          //font-weight: 600;
        `;
  }
};
